import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type, data }) => {
  let structuredData = {};

  switch (type) {
    case 'website':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "ClachSync",
        "alternateName": "クラッシュシンク",
        "url": "https://clashsync.jp",
        "description": "eスポーツ大会の日程を一元管理できる無料カレンダーアプリ",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://clashsync.jp/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      };
      break;

    case 'organization':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ClachSync",
        "url": "https://clashsync.jp",
        "logo": "https://clashsync.jp/logo192.png",
        "sameAs": [
          // ソーシャルメディアのURLを追加
        ]
      };
      break;

    case 'event':
      if (data) {
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SportsEvent",
          "name": data.name || "eスポーツ大会",
          "startDate": data.startDate,
          "endDate": data.endDate,
          "location": {
            "@type": "VirtualLocation",
            "url": data.url || "https://clashsync.jp"
          },
          "organizer": {
            "@type": "Organization",
            "name": data.organizer || "大会主催者"
          },
          "sport": "Esports",
          "description": data.description || "eスポーツトーナメント"
        };
      }
      break;

    case 'breadcrumb':
      if (data && data.items) {
        structuredData = {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data.items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
          }))
        };
      }
      break;

    case 'faq':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "ClachSyncとは何ですか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "ClachSyncは、複数のeスポーツ大会の日程を一元管理できる無料のカレンダーアプリです。お気に入りのチームや大会をフィルタリングして、カスタマイズされたスケジュールを作成できます。"
            }
          },
          {
            "@type": "Question",
            "name": "ClachSyncは無料で使えますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "はい、ClachSyncは完全無料でご利用いただけます。アカウント登録をすることで、フィルター機能やカスタマイズ機能をご利用いただけます。"
            }
          },
          {
            "@type": "Question",
            "name": "どのような大会情報が見られますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "主要なeスポーツタイトルの国内外の大会情報を網羅しています。League of Legends、Valorant、Apex Legendsなど、人気タイトルの大会スケジュールを確認できます。"
            }
          }
        ]
      };
      break;

    default:
      return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
